import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import Breadcrumbs from '../components/Breadcrumbs';
import { JsonLd, breadcrumbSchema } from '../components/JsonLd';
import { developerLabels } from '../config/developers';
import { LANGS, isRtl as rtl } from '../config/langs';
import { ui, projectCount } from '../config/seoCopy';
import { useBuildData } from '../utils/buildData';

/**
 * /developers — the hub of every developer with a page, busiest first, from
 * the list the build wrote (/data/developers.json).
 */
export default function DevelopersPage() {
    const { i18n } = useTranslation();
    const base = (i18n.language || 'ar').split('-')[0];
    const lang = LANGS.includes(base) ? base : 'en';
    const L = developerLabels(lang);
    const U = ui(lang);
    const { data } = useBuildData('developers.json');
    const crumbs = [{ name: U.home, to: '/' }, { name: U.developers }];

    return (
        <div style={{ minHeight: '100vh' }} dir={rtl(lang) ? 'rtl' : 'ltr'}>
            <SEO fullTitle={L.indexTitle} description={L.indexDescription} path="/developers" />
            <JsonLd data={breadcrumbSchema([{ name: U.home, url: '/' }, { name: U.developers, url: '/developers' }])} />
            <Header />
            <main className="container" style={{ padding: '140px 1rem 5rem' }}>
                <Breadcrumbs items={crumbs} />
                <h1 style={{ fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 800, color: '#fff', marginBottom: '1rem' }}>{L.indexH1}</h1>
                <p style={{ color: '#aaa', lineHeight: 1.9, maxWidth: 860, marginBottom: '2.5rem' }}>{L.indexAnswer}</p>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '1rem' }}>
                    {(data || []).map((d) => (
                        <Link
                            key={d.slug}
                            to={`/developer/${d.slug}`}
                            style={{ border: '1px solid rgba(255,255,255,.1)', borderRadius: 12, padding: '1rem 1.25rem', textDecoration: 'none', color: '#fff', background: 'rgba(255,255,255,.02)' }}
                        >
                            <strong style={{ display: 'block', marginBottom: '.35rem' }}>{L.link(d)}</strong>
                            <span style={{ color: '#999', fontSize: '.9rem' }}>{projectCount(d.total, lang)}</span>
                        </Link>
                    ))}
                </div>
            </main>
            <Footer />
        </div>
    );
}
